module.exports = __webpack_public_path__ + "img/symbol_4.d58574ea.png";